import Repository from './Repository';
import {vue} from "../../app";

const url = '/backend';

export default {
    syncData() {
        /**
         * It is important to use dont_append_to_loading_stack, if this is not set, videos will start over while watching
         */
        return Repository.get(`${url}/sync`, {dont_append_to_loading_stack: true, hide_progress_bar: true, dontFlushErrors : true})
            .then((res) => {
                vue.$store.commit('setSettings', res.data.settings);
                vue.$store.commit('setNotifications', res.data.notifications);
            return res;
        });
    },
}
